(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-ajay"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const track = document.querySelector('[data-carousel-track]');
    if (!track) return;

    const items = Array.from(track.querySelectorAll('.js-carousel-item'));
    if (items.length === 0) return;

    const realProductCount = items.filter(item => !item.classList.contains('duplicate')).length;
    const duplicateItems = items.filter(item => item.classList.contains('duplicate')).length;
    
    let currentIndex = 1; // Start at first real product (after duplicate of last)
    let startX = 0;
    let isDragging = false;
    const threshold = 50; // swipe distance threshold

    // Update carousel position and states
    function updateCarousel() {
      const totalItems = items.length;
      
      items.forEach((item, index) => {
        item.classList.remove('center', 'side', 'hidden');
        
        // Calculate relative position
        let relativeIndex = (index - currentIndex + totalItems) % totalItems;
        
        // Normalize to -1, 0, 1 range for visible items
        if (relativeIndex > Math.floor(totalItems / 2)) {
          relativeIndex -= totalItems;
        }
        
        if (relativeIndex === 0) {
          item.classList.add('center');
          item.style.pointerEvents = 'auto';
        } else if (relativeIndex === 1 || relativeIndex === -1) {
          item.classList.add('side');
          item.style.pointerEvents = 'auto';
        } else {
          item.classList.add('hidden');
          item.style.pointerEvents = 'none';
        }
      });

      // Update dots - map to real product index
      const realIndex = (currentIndex - 1) % realProductCount;
      const dots = document.querySelectorAll('.carousel-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === realIndex);
      });
    }

    // Slide to index with seamless looping
    function slideToIndex(index) {
      currentIndex = index;
      updateCarousel();
      
      // Seamless loop: if at last duplicate, snap to first real product
      if (currentIndex >= items.length - 1) {
        setTimeout(() => {
          currentIndex = 1;
          updateCarousel();
        }, 400); // Wait for transition to complete
      }
      
      // Seamless loop: if before first real product, snap to last real product
      if (currentIndex <= 0) {
        setTimeout(() => {
          currentIndex = realProductCount;
          updateCarousel();
        }, 400);
      }
    }

    // Next/Previous slide
    function nextSlide() {
      slideToIndex(currentIndex + 1);
    }

    function prevSlide() {
      slideToIndex(currentIndex - 1);
    }

    // Touch events for swipe
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, false);

    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
      
      isDragging = false;
    }, false);

    // Mouse events for desktop swipe simulation
    track.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      isDragging = true;
      track.style.cursor = 'grabbing';
    }, false);

    document.addEventListener('mouseup', () => {
      if (isDragging && track) {
        isDragging = false;
        track.style.cursor = 'grab';
      }
    }, false);

    track.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      track.style.cursor = 'grabbing';
    }, false);

    // Click handlers for carousel items
    items.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        const isCurrent = item.classList.contains('center');
        
        if (!isCurrent) {
          e.preventDefault();
          slideToIndex(index);
        }
      }, false);
    });

    // Dot navigation
    const dots = document.querySelectorAll('.carousel-dot');
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        slideToIndex(index + 1); // +1 because index 0 is the duplicate last product
      });
    });

    // Initial update
    updateCarousel();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
